import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=7eba4c4c&scoped=true"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=7eba4c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eba4c4c",
  null
  
)

export default component.exports